import { RouterType } from '@online-webinar/router';
import { FollowUpPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/follow-up/$followUpId/'].update({
        staticData: { title: { page: 'EditFollowUp.PageHeading', forWebinar: true } },
        component: authGuard(FollowUpPage, { canBroadcast: true })
    });
};
